import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { Link, NavLink } from "react-router-dom";

import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, clearErrors } from "./../../../actions/authActions";
import { hasPermission, PERMISSIONS } from "./../../../utils/permissions";

const LeftSide = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const { user, loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    if (error) {
      clearErrors();
      return alert.error(error);
    }

    // Only check user properties if user exists
    if (user) {
      if (user.role === "user") {
        alert.error("You are not allowed to login here.");
        logoutHandler();
        return;
      }
      if (user.accountStatus !== "Active") {
        alert.error("Your account is not active or blocked.");
        logoutHandler();
        return;
      }
    }
  }, [dispatch, alert, error, history, user]);

  const logoutHandler = () => {
    dispatch(logoutUser());
    // history.push("/login");
    // history.push("/admin/login");
  };

  const location = useLocation();
  const [reportsOpen, setReportsOpen] = useState(false);

  useEffect(() => {
    // Open reports menu when user is on any /admin/reports route
    if (location && location.pathname && location.pathname.startsWith('/admin/reports')) setReportsOpen(true);
  }, [location]);

  // Show loading state if user is not yet loaded
  if (!user) {
    return (
      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img
                src="/assets/img/user.png"
                className="img-circle"
                alt="User Image"
              />
            </div>
            <div className="pull-left info">
              <p>Loading...</p>
            </div>
          </div>
          <ul className="sidebar-menu" data-widget="tree">
            <li className="header">MAIN NAVIGATION</li>
            <li>
              <NavLink to="/admin" activeStyle={{ background: "#5cb85c", color: "#ffffff" }} exact>
                <i className="fa fa-dashboard"></i> <span>Dashboard</span>
              </NavLink>
            </li>
          </ul>
        </section>
      </aside>
    );
  }

  return (
    <Fragment>
      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
                <img
                  src={
                    user && user.avatarUrl
                      ? user.avatarUrl
                      : "/assets/img/user.png"
                  }
                  className="img-circle"
                  alt="User Image"
                />
            </div>
            <div className="pull-left info">
              <p>{`${user.first_name} ${user.last_name}`}</p>
              {/*<a href="#"><i className="fa fa-circle text-success"></i> Online</a>*/}
            </div>
          </div>

          <ul className="sidebar-menu" data-widget="tree">
            <li className="header">MAIN NAVIGATION</li>
            {hasPermission(user, PERMISSIONS.DASHBOARD_VIEW) && (
            <li>
              <NavLink
                to="/admin"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-dashboard"></i> <span>Dashboard</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.HOME_SETTING_VIEW) && (
            <li>
              <NavLink
                to="/admin/home-setting"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-edit"></i> <span>Home Setting</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, [PERMISSIONS.USERS_VIEW, PERMISSIONS.STUDENTS_VIEW]) && (
            <li className="active treeview">
              <a href="#">
                <i className="fa fa-dashboard"></i> <span>Manage Users</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">
                {hasPermission(user, PERMISSIONS.USERS_VIEW) && (
                <li className="active">
                  <NavLink
                    to="/admin/users"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Admin Users
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.STUDENTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/students"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Students
                  </NavLink>
                </li>
                )}
              </ul>
            </li>
            )}
            {hasPermission(user, [PERMISSIONS.SCHOOLS_VIEW, PERMISSIONS.SCHOOLS_PAYMENTS_VIEW]) && (
            <li className="active treeview">
              <a href="#">
                <i className="fa fa-university"></i> <span>School Portal</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">
                {hasPermission(user, PERMISSIONS.SCHOOLS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/schools"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Registered Schools
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.SCHOOLS_PAYMENTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/school-payments"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Payment Receipts
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.SCHOOLS_EDIT) && (
                <li>
                  <NavLink
                    to="/admin/school-slot-packages"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Slot Packages
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.SCHOOLS_PAYMENTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/school-slot-purchases"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Slot Purchases
                  </NavLink>
                </li>
                )}
              </ul>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.ROLES_VIEW) && (
            <li>
              <NavLink
                to="/admin/roles"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-shield"></i> <span>Roles &amp; Permissions</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.BANNERS_VIEW) && (
            <li>
              <NavLink
                to="/admin/banners"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-image"></i> <span>Banners</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, [PERMISSIONS.CMS_VIEW, PERMISSIONS.NEWS_VIEW, PERMISSIONS.CONTACTUS_VIEW, PERMISSIONS.IMAGE_NOTIFICATION_VIEW]) && (
            <li className="active treeview">
              <a href="#">
                <i className="fa fa-pencil-square-o"></i> <span>CMS</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">
                {hasPermission(user, PERMISSIONS.CMS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/pages"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> CMS Pages
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.NEWS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/news-list"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Manage News
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.CONTACTUS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/contactus"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                  >
                    <i className="fa fa-circle-o"></i> Manage Contact Us
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.IMAGE_NOTIFICATION_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/image-notifications"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Image Notification
                  </NavLink>
                </li>
                )}
              </ul>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.EMAIL_TEMPLATES_VIEW) && (
            <li>
              <NavLink
                to="/admin/emailtemplates"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Email Templates</span>
              </NavLink>
            </li>
            )}

            {hasPermission(user, PERMISSIONS.CATEGORIES_VIEW) && (
            <li>
              <NavLink
                to="/admin/categories"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Categories</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.SUBSCRIPTIONS_VIEW) && (
            <li>
              <NavLink
                to="/admin/subscriptions"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Subscriptions</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.DISCOUNTS_VIEW) && (
            <li>
              <NavLink
                to="/admin/discounts"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-ticket"></i> <span>Discounts</span>
              </NavLink>
            </li>
            )}

            {/* Reports parent menu - groups all reporting pages */}
            {hasPermission(user, PERMISSIONS.REPORTS_VIEW) && (
            <li className={`treeview ${reportsOpen ? 'menu-open active' : ''}`}>
              <a href="#" onClick={(e) => { e.preventDefault(); setReportsOpen(!reportsOpen); }}>
                <i className="fa fa-chart-bar"></i> <span>Reports</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu" style={{display: reportsOpen ? 'block' : 'none'}}>
                {hasPermission(user, PERMISSIONS.REPORTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/reports/paid-users"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Paid Users
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.REPORTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/reports/revenue"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Revenue
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.REPORTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/reports/conversion"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Conversion
                  </NavLink>
                </li>
                )}
                {hasPermission(user, PERMISSIONS.REPORTS_VIEW) && (
                <li>
                  <NavLink
                    to="/admin/reports/retention"
                    activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                    exact
                  >
                    <i className="fa fa-circle-o"></i> Retention
                  </NavLink>
                </li>
                )}
              </ul>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.CURRENCY_SETTINGS_VIEW) && (
            <li>
              <NavLink
                to="/admin/currency-settings"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-money"></i> <span>Currency Settings</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.STUDENT_SUBSCRIPTIONS_VIEW) && (
            <li>
              <NavLink
                to="/admin/student-subscriptions"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i>{" "}
                <span>Student Subscriptions</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.REGISTERED_SUBJECTS_VIEW) && (
            <li>
              <NavLink
                to="/admin/student-registered-subjects"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Registered Subjects</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.EXAMS_VIEW) && (
            <li>
              <NavLink
                to="/admin/exams"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Exams</span>
              </NavLink>
            </li>
            )}

            {hasPermission(user, PERMISSIONS.UNIVERSITY_VIEW) && (
            <li>
              <NavLink
                to="/admin/university"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>University</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.ASSESSMENTS_VIEW) && (
            <li>
              <NavLink
                to="/admin/assessments"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Assessments</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.COURSES_VIEW) && (
            <li>
              <NavLink
                to="/admin/courses"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Courses</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.SUBJECTS_VIEW) && (
            <li>
              <NavLink
                to="/admin/subjects"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Subjects</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.QUESTIONS_VIEW) && (
            <li>
              <NavLink
                to="/admin/question-subjects"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Questions</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.QUESTIONS_VIEW) && (
            <li>
              <NavLink
                to="/admin/question-bank-search"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-search"></i> <span>Question Bank Search</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.ADVICES_VIEW) && (
            <li>
              <NavLink
                to="/admin/advice-list"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Advices</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.NEWSLETTER_VIEW) && (
            <li>
              <NavLink
                to="/admin/subscribenewsletter"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i>{" "}
                <span>Subscribed Newsletter</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.SURVEY_VIEW) && (
            <li>
              <NavLink
                to="/admin/surveys"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-list-alt"></i>{" "}
                <span>User Surveys</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.STUDENTS_EDIT) && (
            <li>
              <NavLink
                to="/admin/email-campaign"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-envelope"></i>{" "}
                <span>Email Campaign</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.TESTIMONIALS_VIEW) && (
            <li>
              <NavLink
                to="/admin/testimonials"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-table"></i> <span>Manage Testimonial</span>
              </NavLink>
            </li>
            )}
            {hasPermission(user, PERMISSIONS.FAQS_VIEW) && (
            <li>
              <NavLink
                to="/admin/faqs"
                activeStyle={{ background: "#5cb85c", color: "#ffffff" }}
                exact
              >
                <i className="fa fa-question-circle"></i>{" "}
                <span>Manage FAQs</span>
              </NavLink>
            </li>
            )}
            {/*<li>
              <NavLink to="/admin/user-theories-exam" activeStyle={{background:'#5cb85c', color:'#ffffff'}} exact>
                <i className="fa fa-table"></i> <span>Theories Exams</span>
              </NavLink>
            </li>*/}

            {/*<li className="treeview">
                            <a href="#">
                                <i className="fa fa-files-o"></i>
                                <span>Layout Options</span>
                                <span className="pull-right-container">
              <span className="label label-primary pull-right">4</span>
            </span>
                            </a>
                            <ul className="treeview-menu">
                                <li><a href="pages/layout/top-nav.html"><i className="fa fa-circle-o"></i> Top Navigation</a></li>
                                <li><a href="pages/layout/boxed.html"><i className="fa fa-circle-o"></i> Boxed</a></li>
                                <li><a href="pages/layout/fixed.html"><i className="fa fa-circle-o"></i> Fixed</a></li>
                                <li><a href="pages/layout/collapsed-sidebar.html"><i className="fa fa-circle-o"></i> Collapsed Sidebar</a></li>
                            </ul>
                        </li>*/}
            {/*<li className="header">LABELS</li>
                        <li><a href="#"><i className="fa fa-circle-o text-red"></i> <span>Important</span></a></li>
                        <li><a href="#"><i className="fa fa-circle-o text-yellow"></i> <span>Warning</span></a></li>
                        <li><a href="#"><i className="fa fa-circle-o text-aqua"></i> <span>Information</span></a></li>*/}
          </ul>
        </section>
      </aside>
    </Fragment>
  );
};

export default LeftSide;
